module.exports = __webpack_public_path__ + "img/state1.e9b10797.png";